import React from "react";
import { SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { Organization } from "chq";
import { useIsMobile } from "app/hooks";
import { CurrentOption, ManualStatus } from "./EffectsSDKCameraRecorder";
import VideoOptions from "./VideoOptions";
import AudioOptions from "./AudioOptions";
import ScreenOption from "./ScreenOption";
import BackgroundOptions from "./BackgroundOptions";
import LayoutOptions from "./LayoutOptions";
import MobileOptions from "./MobileOptions";
import EffectOptions from "./EffectOptions";
import PrompterOption from "./PrompterOption";

interface RecorderOptionsProps {
  audioDevices: { label: any; value: any }[];
  currentOption: CurrentOption;
  effectsSDK: any;
  isDisableOption: (option: CurrentOption) => boolean;
  manualStatus: ManualStatus;
  onFinishRecord: () => void;
  onPause: () => void;
  onResume: () => void;
  onSelectOption: (option: CurrentOption) => void;
  onSelectedAudioDevice: (value: string | SelectValueWithCategory | null) => void;
  onSelectedVideoDevice: (value: string | SelectValueWithCategory | null) => void;
  onSelectRecordMethod: (value: string | SelectValueWithCategory | null) => void;
  onShowScriptChange: (value: string | SelectValueWithCategory | null) => void;
  onStartCountdown: () => void;
  open: boolean;
  organization: Organization;
  screenRecord: boolean;
  selectedAudioDeviceState: string | SelectValueWithCategory | null;
  selectedVideoDeviceState: string | SelectValueWithCategory | null;
  showScript: boolean;
  videoDevices: { label: any; value: any }[];
}

const RecorderOptions: React.FC<RecorderOptionsProps> = ({
  audioDevices,
  currentOption,
  effectsSDK,
  isDisableOption,
  manualStatus,
  onFinishRecord,
  onPause,
  onResume,
  onSelectOption,
  onSelectedAudioDevice,
  onSelectedVideoDevice,
  onSelectRecordMethod,
  onShowScriptChange,
  onStartCountdown,
  open,
  organization,
  screenRecord,
  selectedAudioDeviceState,
  selectedVideoDeviceState,
  showScript,
  videoDevices
}) => {
  const isMobile = useIsMobile();

  if (manualStatus === "stopped") {
    return <div data-testid="empty-container" />;
  }

  return (
    <div className="Options-Container">
      {!isMobile && (
        <>
          <VideoOptions
            currentOption={currentOption}
            isDisableOption={isDisableOption}
            onSelectOption={onSelectOption}
            onSelectedVideoDevice={onSelectedVideoDevice}
            selectedVideoDeviceState={selectedVideoDeviceState}
            videoDevices={videoDevices}
          />
          <AudioOptions
            audioDevices={audioDevices}
            currentOption={currentOption}
            isDisableOption={isDisableOption}
            onSelectOption={onSelectOption}
            onSelectedAudioDevice={onSelectedAudioDevice}
            selectedAudioDeviceState={selectedAudioDeviceState}
          />
          <ScreenOption
            currentOption={currentOption}
            isDisableOption={isDisableOption}
            onSelectRecordMethod={onSelectRecordMethod}
          />
        </>
      )}
      <div className="vertical-divider" />
      {(!isMobile || (isMobile && (manualStatus !== "recording"))) && (
        <>
          <BackgroundOptions
            currentOption={currentOption}
            effectsSDK={effectsSDK}
            isDisableOption={isDisableOption}
            onSelectOption={onSelectOption}
            open={open}
            organization={organization}
          />
          <LayoutOptions
            currentOption={currentOption}
            effectsSDK={effectsSDK}
            isDisableOption={isDisableOption}
            onSelectOption={onSelectOption}
            open={open}
          />
        </>
      )}
      {isMobile && (
        <MobileOptions
          manualStatus={manualStatus}
          onFinishRecord={onFinishRecord}
          onPause={onPause}
          onResume={onResume}
          onStartCountdown={onStartCountdown}
        />
      )}
      {(!isMobile || (isMobile && (manualStatus !== "recording"))) && (
        <>
          <EffectOptions
            currentOption={currentOption}
            effectsSDK={effectsSDK}
            isDisableOption={isDisableOption}
            onSelectOption={onSelectOption}
            open={open}
          />
          <PrompterOption
            isDisableOption={isDisableOption}
            screenRecord={screenRecord}
            showScript={showScript}
            onShowScriptChange={onShowScriptChange}
          />
        </>
      )}
    </div>
  );
};

export default RecorderOptions;
